import PropTypes from 'prop-types';
import cn from 'classnames';
import dynamic from 'next/dynamic';
import { ANIMATION_CASE_STUDY_PROPS } from 'components/CaseStudiesCommon/utils/data';
import Media from 'UI/components/Media';
import { ANIMATED_TYPE } from 'utils/constants';
import { useImages } from './utils/useImages';
import styles from './styles.module.scss';
import LinkWrapper from '../LinkWrapper';

const Animated = dynamic(() => import('UI/containers/Animated'));

const Images = ({ renderVideoPlayer, ...props }) => {
  const {
    type,
    view,
    images,
    links,
  } = useImages(props);

  if (!images) {
    return null;
  }

  return (
    <Animated
      {...ANIMATION_CASE_STUDY_PROPS}
      delay={50}
    >
      <div className={cn(
        styles[type],
        styles[view],
        styles.container,
        links?.length > 0 && styles.imageLinkContainer,
      )}
      >
        {images?.map((asset, index) => {
          const link = links?.[index];

          return (
            <Animated
              key={`image-${index}`}
              type={ANIMATED_TYPE.isCSS}
              intersectedClasses={cn({ [styles.active]: index })}
            >
              {link ? (
                <LinkWrapper
                  path={link}
                >
                  <Media
                    priority
                    transparent
                    unoptimized
                    asset={asset}
                    renderVideoPlayer={renderVideoPlayer}
                    className={cn(styles.image, styles.imageLink, styles[`image-${index + 1}`])}
                    displayParams={{
                      format: 'webp',
                    }}
                  />
                </LinkWrapper>
              ) : (
                <Media
                  priority
                  transparent
                  unoptimized
                  asset={asset}
                  renderVideoPlayer={renderVideoPlayer}
                  className={cn(styles.image, styles[`image-${index + 1}`])}
                />
              )}
            </Animated>
          );
        })}
      </div>
    </Animated>
  );
};

Images.defaultProps = {
  type: 'imageContainer',
  view: '',
  isMobileResolution: false,
};

Images.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  isMobileResolution: PropTypes.bool,
  type: PropTypes.string,
  view: PropTypes.string,
  renderVideoPlayer: PropTypes.func,
};

export default Images;
